<template>
  <div :class="[wrapperClass]">
    <button
      :class="['btn btn-custom-style topbutton', buttonClass]"
      :type="type"
      :style="buttonStyle"
      :disabled="disabled"
      @click="handleClick">
      <template>
        <span :class="{ 'button-label': loading }"><i v-if="icon"
                                                      :class="['mr-2', icon]"/> {{ label }}</span>
      </template>
      <loader v-if="loading"
              v-bind="loader"
              loading/>
    </button>
  </div>
</template>

<script>
import Loader from '../loader'

export default {
	name: 't-button',
	components: { Loader },
	props: {
		type: {
			type: String,
			default: 'submit'
		},
		icon: {
			type: String,
			default: null
		},
		loading: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: 'Button'
		},
		wrapperClass: {
			type: String,
			default: ''
		},
		buttonClass: {
			type: String,
			default: ''
		},
		buttonStyle: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			loader: {
				color: '#fff',
				size: '20px',
				style: {
					'position': 'inherit',
					'top': '-5px'
				}
			}
		}
	},
	methods: {
		handleClick () {
			if (!this.loading) {
				this.$emit('click')
			}
		}
	}
}
</script>
<style>
.btn-custom-style {
	position: relative !important;
	min-height: 2rem;
  min-width: 40px;
}

span.button-label {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/button/index.vue